<template>
  <div class="Fuell-Table">
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item ">
        <span v-t="{path: 'merchant_merchant_name'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'merchant_merchant_matchers'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'merchant_merchant_social_reason'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'merchant_merchant_cif'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'merchant_merchant_identifiers'}"></span>
      </div>

    </div>
    <div class="Fuell-Table--content">
      <merchants-table-row
        :merchant="merchant"
        v-for="merchant in merchants"
        :key="merchant.id"
        @showMerchantDetailModal="showMerchantDetailModal"
      ></merchants-table-row>
    </div>

    <div
      class="Fuell-Table--spinner"
      v-if="isCalling"
    >
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import MerchantsTableRow from './MerchantsTableRow'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'

import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'MerchantsTable',
  components: { MerchantsTableRow, Spinner },
  mixins: [_paginationHandlerMixin],
  computed: {
    merchants () {
      return this.$store.getters['MerchantsStore/merchants']
    },
    currentPage () {
      return this.$store.getters['MerchantsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['MerchantsStore/lastPage']
    },
    isCalling () {
      return this.$store.getters['MerchantsStore/isCalling']
    }
  },
  methods: {

    nextPage () {
      this.$store.dispatch('MerchantsStore/nextPage')
      this.$store.dispatch('MerchantsStore/fetchMerchants')
    },
    showMerchantDetailModal (event) {
      this.$emit('showMerchantDetailModal', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.Fuell-Table--header,
.Fuell-Table--row {
  grid-template-columns: minmax(170px, 1fr) minmax(150px, 0.6fr) minmax(170px, 200px) minmax(150px, 160px) minmax(150px, 0.5fr);
}
</style>
